module.exports = __webpack_public_path__ + "static/media/106.e2f5b73c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/106.jpg
// module id = 922
// module chunks = 0